import { useState, useEffect } from "react"
const useScreenSize = () => {
    const[screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });


    useEffect(() => {
        const onResize = () => {
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);

    return screenSize;
   
};

export default useScreenSize;